import style from './TooltipBase.module.scss';

const TooltipBase = ({ children, className = '' }) => {
  return (
    <span className={`${style.tooltip} ${className}`}>
      <i className={`${style.tooltip_icon} material-symbols-outlined`}>info</i>
      <span className={style.tooltip_content}>{children}</span>
    </span>
  );
};

export default TooltipBase;
